export const offerSvg = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="52.999"
        height="53"
        viewBox="0 0 52.999 53"
    >
        <g id="tag" transform="translate(-0.001 0)" opacity="0.4">
            <g
                id="Group_13294"
                data-name="Group 13294"
                transform="translate(0.001 0.001)"
            >
                <g
                    id="Group_13293"
                    data-name="Group 13293"
                    transform="translate(0 0)"
                >
                    <path
                        id="Path_8385"
                        data-name="Path 8385"
                        d="M52.546.455a1.553,1.553,0,0,0-2.2,0L45.827,4.978a4.669,4.669,0,0,0-.878-.316L30.9,1.19a4.682,4.682,0,0,0-4.424,1.225L1.363,27.482a4.664,4.664,0,0,0,0,6.588L18.931,51.638a4.664,4.664,0,0,0,6.588,0L50.586,26.529a4.682,4.682,0,0,0,1.225-4.424L48.339,8.051a4.679,4.679,0,0,0-.316-.878l4.523-4.523A1.553,1.553,0,0,0,52.546.455ZM48.8,22.859a1.561,1.561,0,0,1-.408,1.475L23.323,49.442a1.555,1.555,0,0,1-2.2,0L3.559,31.874a1.555,1.555,0,0,1,0-2.2L28.667,4.611a1.562,1.562,0,0,1,1.1-.454,1.539,1.539,0,0,1,.373.046l13.2,3.259L39.6,11.2a4.658,4.658,0,1,0,2.2,2.2l3.739-3.739ZM38.695,16.5a1.552,1.552,0,1,1,0-2.2h0A1.554,1.554,0,0,1,38.695,16.5Z"
                        transform="translate(-0.001 -0.001)"
                    />
                </g>
            </g>
            <g
                id="Group_13296"
                data-name="Group 13296"
                transform="translate(17.569 17.336)"
            >
                <g id="Group_13295" data-name="Group 13295">
                    <path
                        id="Path_8386"
                        data-name="Path 8386"
                        d="M177.662,168.833a4.658,4.658,0,1,0,0,6.588A4.664,4.664,0,0,0,177.662,168.833Zm-2.2,4.392a1.553,1.553,0,1,1,0-2.2A1.554,1.554,0,0,1,175.466,173.225Z"
                        transform="translate(-169.712 -167.471)"
                    />
                </g>
            </g>
            <g
                id="Group_13298"
                data-name="Group 13298"
                transform="translate(19.765 32.704)"
            >
                <g id="Group_13297" data-name="Group 13297">
                    <path
                        id="Path_8387"
                        data-name="Path 8387"
                        d="M198.876,317.3a4.658,4.658,0,1,0,0,6.588A4.656,4.656,0,0,0,198.876,317.3Zm-2.2,4.392a1.553,1.553,0,1,1,0-2.2A1.552,1.552,0,0,1,196.68,321.694Z"
                        transform="translate(-190.926 -315.937)"
                    />
                </g>
            </g>
            <g
                id="Group_13300"
                data-name="Group 13300"
                transform="translate(11.888 27.027)"
            >
                <g id="Group_13299" data-name="Group 13299">
                    <path
                        id="Path_8388"
                        data-name="Path 8388"
                        d="M137.695,262.472a1.553,1.553,0,0,0-1.715-1.372l-19.764,2.2a1.553,1.553,0,0,0,.17,3.1,1.593,1.593,0,0,0,.173-.01l19.764-2.2A1.553,1.553,0,0,0,137.695,262.472Z"
                        transform="translate(-114.835 -261.091)"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const qualitySvg = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="41.774"
        height="52.558"
        viewBox="0 0 41.774 52.558"
    >
        <path
            id="achievement"
            d="M165.323,57.677a1.3,1.3,0,0,0,1.094.779c.032,0,.064,0,.1,0a1.3,1.3,0,0,0,1.1-.612l3.139-5.058,5.832,1.194a1.3,1.3,0,0,0,1.45-1.782L173.7,42.146l.411-.175a5.388,5.388,0,0,0,3.252-5.633c-.054-.448-.1-.847-.149-1.2a10.5,10.5,0,0,1-.173-2.707,10.5,10.5,0,0,1,1.089-2.484c.165-.321.348-.679.552-1.081a5.388,5.388,0,0,0-1.129-6.405c-.329-.309-.624-.582-.888-.828a10.487,10.487,0,0,1-1.873-1.962,10.494,10.494,0,0,1-.763-2.6c-.08-.352-.17-.744-.273-1.183a5.388,5.388,0,0,0-4.982-4.181c-.451-.025-.852-.045-1.212-.063a10.5,10.5,0,0,1-2.7-.3,10.5,10.5,0,0,1-2.258-1.5c-.287-.218-.608-.461-.969-.731a5.388,5.388,0,0,0-6.5,0c-.361.27-.682.513-.969.731a10.5,10.5,0,0,1-2.258,1.5,10.5,10.5,0,0,1-2.7.3c-.36.018-.762.038-1.212.063a5.388,5.388,0,0,0-4.982,4.181c-.1.44-.192.831-.273,1.183a10.491,10.491,0,0,1-.763,2.6,10.5,10.5,0,0,1-1.873,1.962c-.264.246-.559.519-.888.828a5.389,5.389,0,0,0-1.13,6.405c.2.4.387.76.551,1.081a10.51,10.51,0,0,1,1.089,2.485,10.5,10.5,0,0,1-.173,2.707c-.045.358-.095.757-.148,1.205a5.388,5.388,0,0,0,3.252,5.633c.415.178.785.334,1.118.474l.291.123-5.313,11.411a1.3,1.3,0,0,0,1.4,1.823l5.865-1.025,2.991,5.147a1.3,1.3,0,0,0,1.12.645h.059a1.3,1.3,0,0,0,1.116-.747L156.6,48.463a6.7,6.7,0,0,1,1.794-.383,10.5,10.5,0,0,1,2.636.641l.507.156Zm5.065-7.608a1.3,1.3,0,0,0-1.361.586l-2.306,3.717-2.2-5.112a5.39,5.39,0,0,0,3.779-2.409c.247-.378.465-.715.661-1.018a10.507,10.507,0,0,1,1.607-2.185,3.785,3.785,0,0,1,.761-.469l3.346,7.769Zm-20.382,6.406-2.2-3.782a1.3,1.3,0,0,0-1.343-.625l-4.309.753,4.207-9.036a13.583,13.583,0,0,1,1.457,2.047c.2.3.414.641.661,1.018a5.381,5.381,0,0,0,4.865,2.45Zm8.383-10.989a11.959,11.959,0,0,0-3.4.757c-.341.105-.72.222-1.146.351a2.782,2.782,0,0,1-3.194-1.162c-.244-.373-.459-.706-.652-1.006-1.858-2.877-2.053-3.04-5.209-4.37-.328-.138-.694-.292-1.1-.468a2.781,2.781,0,0,1-1.7-2.943c.053-.443.1-.837.147-1.19.426-3.4.382-3.648-1.181-6.7-.163-.317-.343-.67-.544-1.068a2.781,2.781,0,0,1,.59-3.347c.325-.3.616-.575.877-.817,2.511-2.329,2.638-2.549,3.4-5.888.079-.348.167-.734.269-1.169a2.781,2.781,0,0,1,2.6-2.184c.445-.025.841-.045,1.2-.062,3.421-.17,3.66-.257,6.389-2.326.284-.215.6-.455.957-.722a2.781,2.781,0,0,1,3.4,0c.357.267.673.507.957.722,2.73,2.068,2.969,2.155,6.389,2.326.356.018.752.037,1.2.062a2.781,2.781,0,0,1,2.6,2.184c.1.434.19.821.269,1.168.762,3.339.889,3.559,3.4,5.888.261.242.552.512.877.817a2.781,2.781,0,0,1,.59,3.347c-.2.4-.382.751-.545,1.068-1.563,3.047-1.607,3.3-1.181,6.7.044.354.094.747.147,1.19a2.781,2.781,0,0,1-1.7,2.943c-.41.175-.775.33-1.1.468-3.156,1.33-3.351,1.493-5.209,4.37-.193.3-.408.633-.652,1.006a2.781,2.781,0,0,1-3.194,1.162c-.427-.129-.806-.246-1.146-.351A11.963,11.963,0,0,0,158.39,45.487ZM171.248,28.66A12.858,12.858,0,1,0,158.39,41.519,12.872,12.872,0,0,0,171.248,28.66ZM158.39,38.927A10.267,10.267,0,1,1,168.657,28.66,10.278,10.278,0,0,1,158.39,38.927Zm7.116-13.322-8.847,8.029a1.3,1.3,0,0,1-1.787-.043l-3.642-3.642a1.3,1.3,0,0,1,1.832-1.832s.094,3.877,2.77,2.77,7.933-7.2,7.933-7.2a1.3,1.3,0,1,1,1.741,1.919Z"
            transform="translate(-137.504 -8.01)"
            fill-rule="evenodd"
            opacity="0.4"
        />
    </svg>
);

 export const originalSvg = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 50 50"
    >
        <g id="original" transform="translate(0)" opacity="0.4">
            <circle
                id="Ellipse_1916"
                data-name="Ellipse 1916"
                cx="0.977"
                cy="0.977"
                r="0.977"
                transform="translate(28.893 28.893)"
            />
            <path
                id="Path_8389"
                data-name="Path 8389"
                d="M49.713,9.921,40.079.287a.979.979,0,0,0-1.385,0L34.753,4.228l-3.046-.092-2.6-2.43a.98.98,0,0,0-1.091-.167l-3.126,1.5L21.749,1.561a.98.98,0,0,0-1.09.175L18.141,4.119,14.7,3.681a.978.978,0,0,0-.984.5L12.06,7.229l-3.405.646a.98.98,0,0,0-.78.78L7.229,12.06,4.185,13.718a.98.98,0,0,0-.5.984l.437,3.439L1.736,20.659a.98.98,0,0,0-.175,1.09l1.475,3.137-1.5,3.126A.979.979,0,0,0,1.708,29.1L4.12,31.688l-.046,3.219L.287,38.694a.98.98,0,0,0,0,1.385l9.634,9.634a.979.979,0,0,0,1.385,0l4.36-4.36,1.649,2.139a.979.979,0,0,0,1.045.344l3.363-.959,2.889,1.97a.979.979,0,0,0,1.1,0l2.9-1.951,3.356.981a.98.98,0,0,0,1.047-.337l2.153-2.756,3.5-.114a.979.979,0,0,0,.889-.646l1.188-3.289,3.289-1.188a.979.979,0,0,0,.646-.889l.114-3.5,2.756-2.153a.98.98,0,0,0,.337-1.047L46.9,28.61l1.951-2.9a.98.98,0,0,0,0-1.1l-1.97-2.889.959-3.363a.98.98,0,0,0-.344-1.045l-2.139-1.649,4.36-4.36a.979.979,0,0,0,0-1.385ZM5.821,30.64,3.6,28.254,5,25.312a.979.979,0,0,0,0-.839L3.618,21.52,5.86,19.15a.979.979,0,0,0,.26-.8l-.411-3.235,2.864-1.56a.979.979,0,0,0,.494-.678l.608-3.205,3.205-.608a.979.979,0,0,0,.678-.494l1.559-2.864,3.235.412a.978.978,0,0,0,.8-.26l2.37-2.242,2.952,1.388a.979.979,0,0,0,.839,0L28.254,3.6,30.64,5.821a.98.98,0,0,0,.639.263l1.571.047L30.522,8.459A17.555,17.555,0,0,0,8.458,30.523l-2.4,2.4.023-1.6a.979.979,0,0,0-.263-.682Zm4.224-1.7a15.592,15.592,0,0,1,18.89-18.89ZM45.771,18.461l-.9,3.165a.98.98,0,0,0,.133.821l1.855,2.72L45.019,27.9a.979.979,0,0,0-.127.821l.924,3.159-2.593,2.026a.979.979,0,0,0-.376.74l-.108,3.29-3.1,1.118a.98.98,0,0,0-.589.589l-1.118,3.1-3.29.108a.98.98,0,0,0-.74.376l-2.026,2.593-3.159-.924a.981.981,0,0,0-.821.127l-2.732,1.837L22.447,45a.979.979,0,0,0-.821-.133l-3.165.9-1.4-1.814,2.24-2.24A17.554,17.554,0,0,0,41.717,19.3l2.24-2.24ZM32.227,26.009a.98.98,0,0,0,1.385,1.385l6.547-6.534a15.592,15.592,0,0,1-19.3,19.3l6.527-6.527A.98.98,0,0,0,26,32.247L10.613,47.635,2.365,39.387,39.387,2.365l8.249,8.249Z"
            />
            <path
                id="Path_8390"
                data-name="Path 8390"
                d="M352.653,109.16l-5.367-2.426-.026-.011a1.106,1.106,0,0,0-1.446,1.449l.009.022,2.412,5.38a.98.98,0,1,0,1.788-.8l-1.491-3.324,3.313,1.5a.98.98,0,0,0,.807-1.785Z"
                transform="translate(-311.965 -96.223)"
            />
            <path
                id="Path_8391"
                data-name="Path 8391"
                d="M283.2,146.706a.979.979,0,0,0-1.372,1.4l1.777,1.743-3.639-.666a.979.979,0,0,0-.869,1.656l3.944,3.944a.98.98,0,1,0,1.385-1.385l-1.722-1.722,3.439.629a1.063,1.063,0,0,0,1.143-.536,1.078,1.078,0,0,0-.23-1.28Z"
                transform="translate(-251.583 -132.126)"
            />
            <path
                id="Path_8392"
                data-name="Path 8392"
                d="M385.07,68.642a.98.98,0,0,0,0,1.385l3.948,3.948a.98.98,0,0,0,1.258.107,20.612,20.612,0,0,0,1.515-1.495.979.979,0,1,0-1.393-1.377l-.684.69-3.258-3.258A.98.98,0,0,0,385.07,68.642Z"
                transform="translate(-347.207 -61.68)"
            />
            <path
                id="Path_8393"
                data-name="Path 8393"
                d="M170.243,284.854a.98.98,0,0,0-1.385,1.385l3.952,3.952a.98.98,0,0,0,1.385-1.385Z"
                transform="translate(-152.109 -256.777)"
            />
            <path
                id="Path_8394"
                data-name="Path 8394"
                d="M257.112,205.89A.98.98,0,0,0,258.5,204.5l-3.952-3.952a.98.98,0,0,0-1.385,1.385Z"
                transform="translate(-228.179 -180.709)"
            />
            <path
                id="Path_8395"
                data-name="Path 8395"
                d="M210.512,233.886a.98.98,0,0,0-1.385,0l-1.182,1.182a.98.98,0,0,0,1.385,1.385l.36-.36a1.6,1.6,0,0,1,.109.427,1.235,1.235,0,0,1-.4,1.046,1.815,1.815,0,1,1-1.63-3.065.98.98,0,0,0-.373-1.923,3.773,3.773,0,1,0,3.388,6.373,3.207,3.207,0,0,0,.965-2.635A4.11,4.11,0,0,0,210.512,233.886Z"
                transform="translate(-184.385 -209.85)"
            />
            <path
                id="Path_8396"
                data-name="Path 8396"
                d="M128.917,319.175l-1.744-.111a2.547,2.547,0,0,0,.14-.757,2.365,2.365,0,0,0-2.462-2.462,2.545,2.545,0,0,0-1.726.749l-1.05,1.05h0a.98.98,0,0,0,0,1.385l3.952,3.952a.98.98,0,1,0,1.385-1.385l-.592-.592,1.974.126.063,0a.98.98,0,0,0,.061-1.957Zm-4.406-1.2a.6.6,0,0,1,.4-.176.444.444,0,0,1,.325.118h0a.439.439,0,0,1,.118.325.6.6,0,0,1-.176.4l-.353.355-.671-.668Z"
                transform="translate(-109.894 -285)"
            />
            <path
                id="Path_8397"
                data-name="Path 8397"
                d="M73.807,366.36a3.774,3.774,0,1,0,2.668,1.105A3.749,3.749,0,0,0,73.807,366.36Zm1.283,5.057a1.815,1.815,0,1,1,0-2.566A1.8,1.8,0,0,1,75.09,371.417Z"
                transform="translate(-63.195 -330.583)"
            />
        </g>
    </svg>
);
export const returnSvg = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
       
        width="51.259"
        height="51.259"
        viewBox="0 0 51.259 51.259"
    >
        <defs>
            <clipPath id="clip-path">
                <path
                    id="path2805"
                    d="M0-682.665H51.259v51.259H0Z"
                    transform="translate(0 682.665)"
                />
            </clipPath>
        </defs>
        <g id="g2799" transform="translate(0 682.665)" opacity="0.4">
            <g id="g2801" transform="translate(0 -682.665)">
                <g id="g2803" clip-path="url(#clip-path)">
                    <g id="g2809" transform="translate(0 0)">
                        <path
                            id="path2811"
                            d="M-315.7-594.41a22.652,22.652,0,0,1-22.626-22.626A22.652,22.652,0,0,1-315.7-639.662a22.652,22.652,0,0,1,22.626,22.626A22.652,22.652,0,0,1-315.7-594.41m18.123-40.749a25.462,25.462,0,0,0-18.123-7.507,25.462,25.462,0,0,0-18.123,7.507,25.462,25.462,0,0,0-7.507,18.123,25.462,25.462,0,0,0,7.507,18.123,25.462,25.462,0,0,0,18.123,7.507,25.462,25.462,0,0,0,18.123-7.507,25.462,25.462,0,0,0,7.507-18.123,25.462,25.462,0,0,0-7.507-18.123"
                            transform="translate(341.332 642.665)"
                        />
                    </g>
                    <g id="g2813" transform="translate(14.711 15.49)">
                        <path
                            id="path2815"
                            d="M-168.942-49.74h-8.588l1.474-1.474a1.5,1.5,0,0,0,0-2.124,1.5,1.5,0,0,0-2.124,0l-4.038,4.038a1.5,1.5,0,0,0,0,2.124l4.038,4.038a1.5,1.5,0,0,0,1.062.44,1.5,1.5,0,0,0,1.062-.44,1.5,1.5,0,0,0,0-2.124l-1.474-1.474h8.588a5.123,5.123,0,0,1,5.117,5.117,5.123,5.123,0,0,1-5.117,5.117h-5.252a1.5,1.5,0,0,0-1.5,1.5,1.5,1.5,0,0,0,1.5,1.5h5.252a8.13,8.13,0,0,0,8.121-8.121,8.13,8.13,0,0,0-8.121-8.121"
                            transform="translate(182.658 53.778)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
